import { Box, Card, Icon, Text } from '@factorialco/deprecated-design-system'
import { RichTextDisplay } from '@factorialco/f0-react/dist/experimental'
import { AtsCandidateEmailActionFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { SmartActionsItemDetail } from '../SmartActions/SmartActionsItem/SmartActionsItemDetail'

interface Props {
  smartAction: AtsCandidateEmailActionFragment
  onToggleAction: (enabled: boolean) => void
}

export const PhaseChangedSmartActionPreview = ({ smartAction, onToggleAction }: Props) => {
  return (
    <Box width="widePage" maxWidth="s600">
      <Card>
        <Card.Eyebrow>
          <Icon.Medium icon="lightbulb" color="grey1000" />
        </Card.Eyebrow>
        <Card.Title size="small">
          {i18n.t('ats.candidates.applications.move_to_phase.modal.smart_action')}
        </Card.Title>
        <Card.Content>
          <Box paddingTop="s12">
            <SmartActionsItemDetail smartAction={smartAction} hiddenDetails={['phase']} />
          </Box>
        </Card.Content>
        <Card.ExpandableContent
          onExpandChange={(enabled) => onToggleAction(!enabled)}
          expanded={smartAction.enabled}
        >
          <RichTextDisplay content={smartAction.messageContent} />

          {smartAction.files.length > 0 && (
            <Box flexDirection="row" gap="s12">
              {smartAction.files.map((atsFile) => (
                <Box key={atsFile.id} flexDirection="row" gap="s8">
                  <Icon.Medium icon="paperclip" color="grey1000" />
                  <Text.Normal color="grey1000">{atsFile.file.filename}</Text.Normal>
                </Box>
              ))}
            </Box>
          )}
        </Card.ExpandableContent>
      </Card>
    </Box>
  )
}
